// extracted by mini-css-extract-plugin
module.exports = {"button":"Pdf_button__KH10q"};